/* TF · Fútbol · CTA flotante móvil. Aparece tras el hero, se oculta al llegar al
 * CTA final, descartable por sesión. Solo actúa; el CSS lo limita a móvil. */
(function () {
  'use strict';
  var KEY = 'tf-fsticky-closed';

  function init() {
    var bar = document.querySelector('[data-tf-sticky]');
    if (!bar || bar.__tf) return; bar.__tf = true;

    var closed = false;
    try { closed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    var closeBtn = bar.querySelector('[data-tf-sticky-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      closed = true; hide();
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });

    var hero = document.querySelector('.tf-futhero');
    var endSel = bar.getAttribute('data-tf-sticky-end') || '.tf-fcta';
    var end = document.querySelector(endSel);

    var pastHero = !hero;   // sin hero, se considera pasado
    var atEnd = false;
    var shown = false;

    function show() {
      if (shown) return; shown = true;
      bar.setAttribute('data-tf-visible', '');
      requestAnimationFrame(function () { bar.classList.add('is-in'); });
    }
    function hide() {
      if (!shown) { bar.removeAttribute('data-tf-visible'); return; }
      shown = false; bar.classList.remove('is-in');
      var t = setTimeout(clear, 420);
      bar.addEventListener('transitionend', function te() { clearTimeout(t); clear(); bar.removeEventListener('transitionend', te); });
      function clear() { if (!shown) bar.removeAttribute('data-tf-visible'); }
    }
    function update() { if (!closed && pastHero && !atEnd) show(); else hide(); }

    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(function (ents) {
        var e = ents[0];
        pastHero = !e.isIntersecting && e.boundingClientRect.top <= 0;
        update();
      }, { threshold: 0 }).observe(hero);
      if (end) new IntersectionObserver(function (ents) {
        atEnd = ents[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(end);
    }
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
